export const Environment = {
    BACKEND_API: process.env.REACT_APP_awsApiUri,
};
